import type {
  IMediaLibDialogItem,
  TElement,
} from "@editor/modules/media-lib/types";
import {
  type ComponentType,
  createContext,
  type ReactNode,
  useContext,
} from "react";
import type { IBrandfetchBrand } from "@/shared/types";
import type { IMediaLibLogo } from "../types";

interface IState {
  logosData: IMediaLibLogo[];
  setLogosData: (value: IMediaLibLogo[]) => void;
  updateLogoData: (idx: number, value: Partial<IMediaLibLogo>) => void;
  setBrand: (value: IBrandfetchBrand | null) => void;

  isMultiSelect?: boolean;
  selectedItems?: IMediaLibDialogItem[];
  onSelect?: (item: IMediaLibLogo) => void;
  elementWrapper?: ComponentType<{ children: ReactNode; element: TElement }>;
  view?: "panel" | "dialog";
}

const initState: IState = {
  logosData: [],
  view: "panel",
  setLogosData: () => {},
  updateLogoData: () => {},
  setBrand: () => {},
};

export const MediaLibLogoFinderCtx = createContext<IState>(initState);

interface IProps {
  children: ReactNode;
  ctxState: IState;
}

export const MediaLibLogoFinderCtxProvider = ({
  children,
  ctxState,
}: IProps) => {
  return (
    <MediaLibLogoFinderCtx.Provider value={ctxState}>
      {children}
    </MediaLibLogoFinderCtx.Provider>
  );
};

export const useMediaLibLogoFinderCtx = () => {
  const ctx = useContext(MediaLibLogoFinderCtx);
  if (!ctx)
    throw Error(
      "useMediaLibLogoFinderCtx: MediaLibLogoFinderCtx is not defined!",
    );
  return ctx;
};
